import { apiClient } from './client';

export interface PendingUser {
  id: string;
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  signupDate: string;
  status: string;
  tenant?: {
    id: string;
    name: string;
    shortCode: string;
  };
  roles: Array<{
    id: string;
    name: string;
    displayName: string;
  }>;
  hasRoleAssignment: boolean;
  tokenExpiry?: string;
}

export interface PaginatedPendingUsers {
  data: PendingUser[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
    hasMore: boolean;
  };
}

export interface BulkApprovalResult {
  totalProcessed: number;
  successCount: number;
  failureCount: number;
  results: {
    successful: Array<{ userId: string; message: string }>;
    failed: Array<{ userId: string; error: string }>;
  };
}

/**
 * Get list of pending users
 */
export const getPendingUsers = async (
  page: number = 1,
  pageSize: number = 25,
  search: string = ''
): Promise<PaginatedPendingUsers> => {
  const response = await apiClient.get('/auth/pending-users', {
    params: { page, pageSize, search }
  });
  return response.data;
};

/**
 * Approve a pending user
 */
export const approvePendingUser = async (userId: string): Promise<any> => {
  const response = await apiClient.post(`/auth/pending-users/${userId}/approve`);
  return response.data;
};

/**
 * Reject a pending user
 */
export const rejectPendingUser = async (userId: string, reason?: string): Promise<any> => {
  const response = await apiClient.post(`/auth/pending-users/${userId}/reject`, { reason });
  return response.data;
};

/**
 * Bulk approve pending users
 */
export const bulkApprovePendingUsers = async (userIds: string[]): Promise<BulkApprovalResult> => {
  const response = await apiClient.post('/auth/pending-users/bulk-approve', { userIds });
  return response.data.data;
};

/**
 * Resend activation email
 */
export const resendActivationEmail = async (userId: string): Promise<any> => {
  const response = await apiClient.post(`/auth/pending-users/${userId}/resend-activation`);
  return response.data;
};
